import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export type PageShellVariant = "gradient" | "lavender" | "warm" | "plain" | "muted";

const variantClass: Record<PageShellVariant, string> = {
  gradient:
    "bg-gradient-to-br from-white to-blue-50 dark:from-gray-950 dark:to-slate-900",
  lavender:
    "bg-gradient-to-br from-[#ededff] to-blue-50 dark:from-slate-900 dark:to-gray-950",
  warm: "bg-[#f7f6f3] dark:bg-gray-950",
  plain: "bg-white dark:bg-gray-950",
  muted: "bg-[#f8f9fa] dark:bg-gray-950",
};

type PageShellProps = {
  children: ReactNode;
  variant?: PageShellVariant;
  className?: string;
};

export function PageShell({
  children,
  variant = "gradient",
  className,
}: PageShellProps): JSX.Element {
  return (
    <div
      className={cn(
        "relative w-full min-h-screen text-foreground",
        variantClass[variant],
        className,
      )}
    >
      {children}
    </div>
  );
}
